import React, { useEffect, useState } from "react";
import HttpApis from "../../services/HttpApis";
import { useNavigate, useParams } from "react-router-dom";
import { trackUserClick } from "../../services/Analytics";
import { useConfig } from "../../ConfigContext";
import "./Genre.css";
import SpinLoader from "../loader/SpinLoader";

const Genre = () => {
  const [genreData, setGenreData] = useState(null);
  const { genre_id } = useParams();
  const navigate = useNavigate();
  const config = useConfig();
  const enableLogin = config?.enable_login !== false;

  const fetchGenre = async (id) => {
    try {
      const response = await HttpApis.getGenrebyId(id);
      const data = response?.data;
      if (data && data.status === "success") setGenreData(data);
    } catch (error) {
      console.error("Error fetching genre:", error);
    }
  };

  useEffect(() => {
    if (genre_id) fetchGenre(genre_id);
  }, [genre_id]);

  if (!genreData) return <SpinLoader/>;

  const allItems = genreData.data || [];

  const handleItemClick = async (item) => {
    if (!item?.slug) return;
    
    if (enableLogin) {
      await trackUserClick({
        action: "genre_item_click",
        contentId: item.slug || item.id,
        contentType: item.type,
        contentTitle: item.name,
        genreId: genre_id,
        genreTitle: genreData.title
      });
    }
    
    const type = item.type;
    navigate(`/details/${type}/${item.slug}`);
  };

  return (
    <div className="genre-page">
      <div className="genre-header">
        <h1 className="genre-title">{genreData.title}</h1>
      </div>

      <div className="genre-items">
        {allItems.map((item, index) => (
          <div
            key={item.id || index}
            className="genre-card"
            onClick={() => handleItemClick(item)}
          >
            <div className="card-image-wrapper">
              {(item.thumbnail || item.landscape) ? (
                <img
                  src={item.thumbnail || item.portrait}
                  alt={item.name}
                  className="genre-thumb"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "block";
                  }}
                />
              ) : null}
              <div
                className="fallback-box"
                style={{
                  display:
                    item.thumbnail || item.landscape ? "none" : "block",
                }}
              ></div>

              <div className="overlay">
                <p className="genre-card-title">{item.name}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Genre;